var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { ChartParams } from "app/views/chart/chart.component";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { ChartModel } from "app/models/chart.model";
import { BillingService2 } from "../billing.service";
var MoneyComponent = /** @class */ (function (_super) {
    __extends(MoneyComponent, _super);
    function MoneyComponent(activatedRoute, translate, filter, eventsService, money, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.money = money;
        _this.service2 = service2;
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated'],
            promocodeMark: ''
        };
        _this.accumFirst = new ChartParams({
            filter: {
                datePeriodList: []
            }
        });
        _this.moneyChart = new ChartParams({
            filter: {
                datePeriodList: []
            }
        });
        _this.amountPeriodChart = new ChartParams({
            filter: {
                datePeriodList: []
            }
        });
        _this.accumSecondPaidChart = new ChartParams({
            filter: {
                datePeriodList: []
            }
        });
        _this.secondManualChart = new ChartParams({
            filter: {
                datePeriodList: []
            }
        });
        var labels = {
            moneyCount: _this.translate.__A('billing._money.moneyCount'),
            firstManualMoneyCount: _this.translate.__A('billing._money.firstManualMoneyCount'),
            rebuildAndSecondManualMoneyCount: _this.translate.__A('billing._money.rebuildAndSecondManualMoneyCount'),
            secondManualMoney: _this.translate.__A('billing._money.secondManualMoney'),
            recurrentMoneyCount: _this.translate.__A('billing._money.recurrentMoneyCount'),
            avgCheck: _this.translate.__A('billing._money.avg check'),
            avgPaidPeriod: _this.translate.__A('billing._money.avg paid period'),
            current: _this.translate.__A('billing._money.current'),
            yesterday: _this.translate.__A('billing._money.yesterday'),
            accumPaidInCurrentDayOfWeek: _this.translate.__A('billing._money.accumPaidInCurrentDayOfWeek'),
            avgFirstManual: _this.translate.__A('billing._money.avg first manual'),
            avgFirstManualPeriod: _this.translate.__A('billing._money.avg first manual period')
        };
        _this.accumFirst.setOptions({
            title: _this.translate.__A('billing._money.cumulative payment graph'),
            names: labels,
            colors: {
                yesterday: 'rgb(255, 127, 14)',
                current: 'rgb(140, 86, 75)',
                accumPaidInCurrentDayOfWeek: '#0AC2FF'
            },
            keysMap: [
                'yesterday',
                'accumPaidInCurrentDayOfWeek',
                'current'
            ],
            axis: {
                x: {
                    type: 'indexed'
                }
            }
        });
        _this.moneyChart.setOptions({
            title: _this.translate.__A('common.Money'),
            showLabels: [
                'moneyCount', 'firstManualMoneyCount', 'rebuildAndSecondManualMoneyCount'
            ],
            colors: {
                'moneyCount': '#2ca02c',
                'firstManualMoneyCount': '#8c564b',
                'rebuildAndSecondManualMoneyCount': '#bcbd22'
            },
            names: labels,
            axis: {
                x: {
                    tick: {
                        fit: false,
                        format: '%d-%m-%Y'
                    }
                }
            }
        });
        _this.amountPeriodChart.setOptions({
            title: _this.translate.__A('billing._money.check and period'),
            showLabels: [
                'avgPaidPeriod', 'avgCheck', 'avgFirstManual', 'avgFirstManualPeriod'
            ],
            axes: {
                avgPaidPeriod: 'y',
                avgCheck: 'y2',
                avgFirstManual: 'y2',
                avgFirstManualPeriod: 'y'
            },
            names: labels,
            colors: {
                avgCheck: '#9467bd',
                avgPaidPeriod: '#e377c2'
            },
            axis: {
                y: {
                    min: 1,
                    ticks: 5,
                    label: {
                        text: labels.avgPaidPeriod,
                        position: 'outer-middle'
                    }
                },
                y2: {
                    show: true,
                    label: {
                        text: labels.avgCheck,
                        position: 'outer-middle'
                    }
                }
            }
        });
        _this.accumSecondPaidChart.setOptions({
            title: _this.translate.__A('billing._money.cumulative payment graph repeated manul'),
            names: labels,
            colors: {
                yesterday: 'rgb(255, 127, 14)',
                current: 'rgb(140, 86, 75)',
                accumPaidInCurrentDayOfWeek: '#0AC2FF'
            },
            keysMap: [
                'yesterday',
                'accumPaidInCurrentDayOfWeek',
                'current'
            ],
            axis: {
                x: {
                    type: 'indexed'
                }
            }
        });
        _this.secondManualChart.setOptions({
            title: 'Вторичные ручные платежи',
            names: {
                expiredCount: 'Просроченный платный тариф',
                activeCount: 'Активный платный тариф',
                paidWithoutFirstManualCount: 'Оплата без предыдущей оплаты',
            }
        });
        return _this;
    }
    MoneyComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, fp, accumFirstData, accumSecondPaidChartData, secondManualChartData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        fp = me.filter.getFilterParams();
                        me.accumFirst.showLoader();
                        return [4 /*yield*/, me.service2.money.chart(me.filter.getCopyFilterParams({
                                paidType: 'firstManual',
                                chartFormat: 'c3angular'
                            }), 'accum/chart').toPromise()];
                    case 1:
                        accumFirstData = (_a.sent()).charts;
                        me.accumFirst.data = accumFirstData;
                        me.accumFirst.hideLoader();
                        return [4 /*yield*/, me.getMoneyTotal(fp)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, me.getAmountPeriod(fp)];
                    case 3:
                        _a.sent();
                        me.accumSecondPaidChart.showLoader();
                        return [4 /*yield*/, me.service2.money.chart(me.filter.getCopyFilterParams({
                                paidType: 'secondManual'
                            }), 'accum/chart').toPromise()];
                    case 4:
                        accumSecondPaidChartData = (_a.sent()).charts;
                        me.accumSecondPaidChart.data = accumSecondPaidChartData;
                        me.accumSecondPaidChart.hideLoader();
                        me.secondManualChart.showLoader();
                        return [4 /*yield*/, me.service2.money.chart(fp, 'second_manual').toPromise()];
                    case 5:
                        secondManualChartData = (_a.sent()).charts;
                        me.secondManualChart.data = secondManualChartData;
                        me.secondManualChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    MoneyComponent.prototype.getAmountPeriod = function (fp) {
        return __awaiter(this, void 0, void 0, function () {
            var me, amountPeriodChartData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.amountPeriodChart.showLoader();
                        return [4 /*yield*/, me.service2.money.chart(fp, 'moneyTotal2Data').toPromise()];
                    case 1:
                        amountPeriodChartData = (_a.sent()).charts;
                        me.amountPeriodChart.data = amountPeriodChartData;
                        me.amountPeriodChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    MoneyComponent.prototype.getMoneyTotal = function (fp) {
        return __awaiter(this, void 0, void 0, function () {
            var me, moneyChartData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.moneyChart.showLoader();
                        return [4 /*yield*/, me.service2.money.chart(fp, 'moneyTotalData').toPromise()];
                    case 1:
                        moneyChartData = (_a.sent()).charts;
                        me.moneyChart.data = moneyChartData;
                        me.moneyChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    MoneyComponent.prototype.updateData = function (filter, chartServiceName) {
        return __awaiter(this, void 0, void 0, function () {
            var fp, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fp = this.filter.getCopyFilterParams(filter);
                        _a = chartServiceName;
                        switch (_a) {
                            case 'money': return [3 /*break*/, 1];
                            case 'period': return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, this.getMoneyTotal(fp)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.getAmountPeriod(fp)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return MoneyComponent;
}(BaseComponent));
export { MoneyComponent };
